export default __webpack_public_path__ + "static/media/wordpress.1d319c09.svg";